import CategoryButtons from 'components/buttons/categoryButtons/categoryButtons'
import { useHeadbandContext } from 'contexts/headband'
import HTMLReactParser from 'html-react-parser'
import { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './headband.scss'
/**
 * Crée un bandeau contenant un titre
 */
export default function Headband() {
   const { headband } = useHeadbandContext()
   const location = useLocation()
   const IS_VISITEUR = location.pathname.includes('visiteur')
   useEffect(() => {
      document.title = headband !== null ? headband.replace('<br/>', ' ') : 'accueil'
   }, [headband])
   return (
      <div className='bandeau'>
         <div id='changeLanguage' className='flex column'>
            <Link to={`${IS_VISITEUR ? '/accueil/visiteur' : '/accueil'} `}>
               <img src={`${process.env.PUBLIC_URL}/img/picto_home_gris_fonce_-_2023.png`} alt='home button' />
            </Link>
         </div>
         <div className='w100' style={{ padding: '0 40px' }}>
            <p style={{ height: headband === ' ' ? '100px' : '210px' }}>
               {headband != null && HTMLReactParser(headband)}
            </p>
            <CategoryButtons />
         </div>
      </div>
   )
}
